import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';
import { useAuthState } from '@contexts/auth/AuthContext';
import { SeturLoyaltyPointsViewModel } from '@api/v3';
import { getSafeLocalStorageItem } from '@utils/localStorage/getSafeLocalStorage';

// ======================================
// Get the current user Setur point
// ======================================
export const usePointHistoryv2 = (
  isEnabled: boolean,
  queryKeyDeps?: string[]
) => {
  const { loginInfo } = useAuthState();

  const [userSeturPoints, setUserSeturPoints] =
    useState<SeturLoyaltyPointsViewModel | null>(null);

  useEffect(() => {
    const points = getSafeLocalStorageItem('seturPoints');

    if (points) {
      setUserSeturPoints(JSON.parse(points));
    }
  }, []);

  const { data, isSuccess } = useQuery(
    [
      'loyaltyPoints',
      JSON.stringify(loginInfo),
      ...(queryKeyDeps ? queryKeyDeps : []),
    ],
    async () =>
      callService(
        {
          service: 'LoyaltiesService',
          method: 'pointsHistoryV2',
          version: 'v3',
        },
        {
          authorization: loginInfo?.token ? loginInfo.token : '',
        }
      ),
    {
      enabled: isEnabled && !userSeturPoints,
      staleTime: 1000 * 60 * 60 * 8,
      cacheTime: 1000 * 60 * 60 * 8,
    }
  );

  useEffect(() => {
    if (isSuccess) {
      setUserSeturPoints(data);
    }
  }, [isSuccess, data]);

  return { userSeturPoints };
};
